<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">400号码秒杀查询</a></li>
            </ul>
        </div>
        <div id="usual1" class="usual">  
            <div class="formbody">            
            <table class="tablelist" style="border-collapse:collapse;table-layout:fixed;">
                <thead>
                <tr>
                    <th width="20%">门牌号</th>
                    <th width="20%">号码</th>
                    <th width="10%">状态</th>
                    <th width="20%">时间</th>
                </tr>
                </thead>
                <tbody>
                
                <tr v-for="(item,index) in seconds400ActivityRecordList" :class="{odd:index%2!=0}">
                    <td width="35%" >{{item.account}}</td>
                    <td width="5%" :title="item.channel">{{item.phone}}</td>
                    <td width="5%" >
                        <ol v-if="item.status == 0">
                            <label style="color: red;">待开通</label>
                            <!-- <a target="_blank" href="http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDAyMDIxNF80ODkyNjJfODAwMDIwMjE0XzJf">
                                <img border="0" src="http://wpa.qq.com/pa?p=2:800020214:41" style="margin-top: 3px;" alt="点击咨询" title="点击咨询"/>
                            </a> -->
                        </ol>
                        <ol v-if="item.status == 1">已开通</ol>
                    </td>
                    <td width="10%" :title="item.createdate">{{item.createTime}}</td>
                </tr>
                </tbody>
            </table>
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
            <div class="jian">&nbsp;</div>        
            </div> 

            <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                top: 0; left: 0;display: block;" v-show="loadingShow"></div>
            <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
            </div>

        </div> 
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'

export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            pageIndex:0,
            totalCount:0,
            seconds400ActivityRecordList:[],
            loadingShow: true,
        }
    },
    mounted(){
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val){
            this.pageChange(val);
        },
        handleCurrentChange(val){
            this.pageChange(val);
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            let that = this;
            let data = {'pageSize':50,pageIndex:pageIndex};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/main/qrypageseconds400activityrecord.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.seconds400ActivityRecordList = res.data.seconds400ActivityRecordList;
                    that.pageIndex = parseInt(pageIndex);
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg);
                    return false;
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/seconds400activityrecord.vue